<template>
  <div>
    <v-autocomplete
      :error-messages="validationMessage"
      :items="items"
      :label="contextLabel"
      :menu-props="{ value: false }"
      @focusin.native="dialog = true"
      append-icon="cloud_upload"
      item-text="itemName"
      item-value="id"
      v-model="contextModel"
    >
      <div
        slot="selection"
        slot-scope="data"
        style="
      width: calc(100% - 15px);
    height: 32px;"
      >
        <v-chip
          :key="JSON.stringify(data.item)"
          :input-value="data.selected"
          @input="data.parent.selectItem(data.item)"
          small
          style="max-width: 100%; overflow: hidden"
        >
          {{ data.item.itemName }}
        </v-chip>
      </div>
    </v-autocomplete>
    <v-dialog max-width="500px" persistent v-model="dialog">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("components.ajaxFile.headline") }}</span>
        </v-card-title>
        <v-card-text :key="item.id" v-for="item in items">
          <v-card
            v-bind:class="{
              'green accent-1': item.uploadedSize === item.fileSize
            }"
          >
            <v-card-text>
              <v-row>
                <v-col cols="9"
                  ><strong style="word-wrap: break-word">{{ item.itemName }}</strong> <br />({{ Number.parseFloat(item.fileSize / 1000).toFixed(1) }} KB)
                  {{ item.status }}
                </v-col>
                <v-spacer />
                <v-col style="white-space: nowrap">
                  <v-tooltip top>
                    <template #activator="{on}">
                      <v-btn :disabled="$store.getters['Ajax/loading']" @click="downloadFile(item)" icon v-on="on">
                        <v-icon>cloud_download</v-icon>
                      </v-btn>
                    </template>
                    {{ $t("global.downloadFile") }}
                  </v-tooltip>
                  <v-tooltip top v-if="readonly !== true">
                    <template #activator="{on}">
                      <v-btn :disabled="$store.getters['Ajax/loading']" @click="removeFile(item)" icon v-on="on">
                        <v-icon>close</v-icon>
                      </v-btn>
                    </template>
                    {{ $t("global.removeFile") }}
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-progress-linear :value="(item.uploadedSize / item.fileSize) * 100" v-if="item.uploadedSize !== item.fileSize" />
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-text>
          <v-row v-if="readonly !== true">
            <v-col class="ma-3">
              <form ref="inputForm">
                <v-btn @click="$refs.fileInput.click()" class="primary">{{ $t("global.choseFile") }}</v-btn>
                <input @change="upload($event)" ref="fileInput" style="display: none" type="file" v-if="uploadButton" :accept="accept" />
              </form>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn @click.native="dialog = false" color="blue darken-1" text>{{ $t("global.close") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import fileDownload from "../../repository/downloadFile";

export default {
  name: "AjaxSingleFile",
  props: {
    readonly: {
      default: false,
      required: false
    },
    accept: {
      type: String,
      required: false,
      default: "*"
    },
    items: {
      type: Array,
      required: true
    },
    validationMessage: {
      type: Array,
      default: function() {
        return [];
      }
    },
    model: {
      required: true
    },
    label: {
      required: false,
      default: null
    },
    maxFileSizeKB: {
      type: Number,
      default: 3072,
      required: false
    }
  },
  data: () => ({
    newId: -1,
    uploadButton: true,
    dialog: false,
    validationError: false,
    //validationMessage: [],
    componentItems: [],
    search: "",
    uploadedFile: null,
    loading: false
  }),
  watch: {
    selectModel(val) {
      this.onChange(val);
    }
  },
  computed: {
    contextLabel() {
      if (this.label === null) return this.$t("components.ajaxFile.label");
      return this.label;
    },
    contextModel: {
      set: function(value) {
        this.$emit("update:model", value);
      },
      get: function() {
        return this.model;
      }
    }
  },
  methods: {
    upload(event) {
      if (this.items.length > 0) {
        this.removeFile(this.items[this.items.length - 1]);
      }

      const dataToSend = new FormData();
      const file = event.target.files[0];
      if (file.size > this.maxFileSizeKB * 1024) {
        this.$store.dispatch("alertDialog", {
          content: this.$t("components.file.fileToLargeCustomLimit.content") + this.maxFileSizeKB + " KB.",
          title: this.$t("components.file.fileToLargeCustomLimit.title")
        });
      } else {
        dataToSend.append("filename", "test");
        dataToSend.append("file", file);
        this.uploadButton = false;
        this.$nextTick(() => {
          this.uploadButton = true;
        });
        const newItem = {
          id: this.newId--,
          itemName: file.name,
          status: this.$t("global.loading"),
          fileSize: file.size,
          uploadedSize: 0
        };
        this.items.push(newItem);
        const temp = this;
        this.axios({
          url: "file/upload-file",
          data: dataToSend,
          method: "POST",
          onUploadProgress: function(progressEvent) {
            newItem.uploadedSize = progressEvent.loaded;
          }
        })
          .then(function(result) {
            newItem.status = temp.$t("global.loaded");
            newItem.id = result.data.id;
            temp.contextModel = result.data.id;
            temp.$emit("fileUploaded", newItem);
          })
          .catch(function(error) {
            console.log("Error Result"); // console logi w razie problemów żeby użytkownik mógł opisać problem
            console.log(error.message);
            console.log(error.response);
            console.log(error.request);
            temp.removeFile(newItem);
            temp.$store.dispatch("alertDialog", {
              content: this.$t("components.file.errorDialog.content") + error.response.status,
              title: this.$t("components.file.errorDialog.title")
            });
          });
      }
    },

    removeFile(item) {
      this.items.splice(this.items.indexOf(item), 1);
      this.$emit("fileRemoved", item);
      this.contextModel = null;
      //TODO ajax remove request?
    },

    downloadFile(item) {
      fileDownload("file/download-file?fileId=" + item.id);
    }
  },
  created() {}
};
</script>

<style scoped>
.chip--small {
  height: 22px;
}
</style>
